/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selectacategory2Inputs */

const en_selectacategory2 = /** @type {(inputs: Selectacategory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a category`)
};

const de_selectacategory2 = /** @type {(inputs: Selectacategory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl eine Kategorie`)
};

/**
* | output |
* | --- |
* | "Select a category" |
*
* @param {Selectacategory2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const selectacategory2 = /** @type {((inputs?: Selectacategory2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selectacategory2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selectacategory2(inputs)
	return de_selectacategory2(inputs)
});
export { selectacategory2 as "selectACategory" }